import { logError } from 'helpers/errors';
import { StateCreator } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

const THIRTY_DAYS_IN_SECONDS = 2592000;

const getDomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    return parts.length > 1 ? `.${parts[parts.length - 2]}.${parts[parts.length - 1]}` : hostname;
};

const globalCookieStorage = {
    getItem: (_key: string) => {
        // Not implemented
        return null;
    },
    removeItem: (_key: string) => {
        // Not implemented
    },
    setItem: (key: string, value: string) => {
        try {
            const maxAge = THIRTY_DAYS_IN_SECONDS;
            const path = '/';
            const domain = getDomain();
            const sameSite = 'Lax';
            const secure = 'secure';
            const parts = [
                `${key}=${encodeURIComponent(value)}`,
                `max-age=${maxAge}`,
                `path=${path}`,
                `domain=${domain}`,
                `SameSite=${sameSite}`,
                secure,
            ];
            document.cookie = parts.join('; ');
        } catch (e) {
            logError(e as Error);
        }
    },
};

interface ReferralData {
    growSurfId: string | null;
    referralUrl: string | null;
}

interface ReferralState extends ReferralData {
    setReferralData: (data: ReferralData) => void;
}

type CookieStorageState = ReferralState;

const createReferralSlice: StateCreator<
    CookieStorageState,
    [['zustand/persist', unknown]],
    [],
    ReferralState
> = set => ({
    referralUrl: null,
    growSurfId: null,
    setReferralData: (data: ReferralData) => set(data),
});

export const useReferralCookie = create<CookieStorageState>()(
    persist(
        (...params) => ({
            ...createReferralSlice(...params),
        }),
        {
            name: 'gb-referral-data',
            storage: createJSONStorage(() => globalCookieStorage),
        },
    ),
);
